(function(){
  var modal = document.getElementById('bs-modal');
  var modalImg = document.getElementById('bs-modalimg');
  var modalImgWrap = document.getElementById('bs-modalimgwrap');
  var modalRotate = document.getElementById('bs-modalrotate');
  var modalRotateBtn = document.getElementById('bs-modalrotatebtn');
  if (!modal || !modalImg || !modalImgWrap) return;

  function isMeld(card){ return String(card && card.layout || '').toLowerCase() === 'meld'; }

  var MELD_BACK_HALF_BY_NAME = {
    "Graf Rats":"bottom",
    "Midnight Scavengers":"top",
    "Hanweir Garrison":"bottom",
    "Hanweir Battlements":"top",
    "Bruna, the Fading Light":"bottom",
    "Gisela, the Broken Blade":"top",
    "Urza, Lord Protector":"bottom",
    "The Mightstone and Weakstone":"top"
  };

  function meldBackHalf(card){
    var n = String(card && card.name || '');
    return MELD_BACK_HALF_BY_NAME[n] || 'bottom';
  }

  function clearMeldModal(){
    modalImg.classList.remove('meld-top','meld-bottom');
    modalImgWrap.classList.remove('meld-back','meld-top-bg','meld-bottom-bg');
    modalImgWrap.style.removeProperty('--meld-bg');
  }

  function applyMeldModal(backSrc, card){
    clearMeldModal();
    if (!backSrc) return;
    if (!isMeld(card)) return;

    var half = meldBackHalf(card);
    modalImgWrap.classList.add('meld-back');
    modalImgWrap.style.setProperty('--meld-bg', 'url("' + backSrc + '")');

    if (half === 'top'){
      modalImg.classList.add('meld-top');
      modalImgWrap.classList.add('meld-top-bg');
    } else {
      modalImg.classList.add('meld-bottom');
      modalImgWrap.classList.add('meld-bottom-bg');
    }
  }

  var st = { open:false, face:0, front:'', back:'', alt:'', card:null, getBackFn:null };

  function openModal(frontSrc, backSrcOrFn, alt, cardObj){
    st.open = true;
    st.face = 0;
    st.front = frontSrc || '';
    st.alt = alt || '';
    st.card = cardObj || null;
    st.getBackFn = null;
    st.back = '';

    if (typeof backSrcOrFn === 'function') st.getBackFn = backSrcOrFn;
    else st.back = backSrcOrFn || '';

    modalImg.alt = st.alt;
    clearMeldModal();
    modalImg.src = st.front;

    if (modalRotate) modalRotate.style.display = (st.back || st.getBackFn) ? '' : 'none';

    modal.classList.add('open');
    modal.setAttribute('aria-hidden','false');
  }

  async function ensureBack(){
    if (st.back) return st.back;
    if (st.getBackFn){
      try{
        var b = await st.getBackFn();
        st.back = b || '';
        return st.back;
      }catch(e){ return ''; }
    }
    return '';
  }

  function closeModal(){
    st.open = false;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden','true');
    modalImg.src = '';
    modalImg.alt = '';
    clearMeldModal();
    st.front = st.back = '';
    st.face = 0;
    st.card = null;
    st.getBackFn = null;
    if (modalRotate) modalRotate.style.display = 'none';
  }

  window.openModal = openModal;

  modal.addEventListener('click', closeModal);
  modalImg.addEventListener('click', function(e){ e.stopPropagation(); closeModal(); });

  if (modalRotateBtn){
    modalRotateBtn.addEventListener('click', async function(e){
      e.preventDefault(); e.stopPropagation();
      var back = await ensureBack();
      if (!back) return;

      st.face = (st.face === 0) ? 1 : 0;
      if (st.face === 0){
        clearMeldModal();
        modalImg.src = st.front;
      } else {
        modalImg.src = back;
        applyMeldModal(back, st.card);
      }
    });
  }

  document.addEventListener('keydown', function(e){
    if (!st.open) return;
    if (e.key === 'Escape') closeModal();
  });
})();
